// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
  width: 12.4285714286rem;
  height: 12.4285714286rem;
  padding-top: 4.1428571429rem;
  transition: all linear 0.3s;
}

.logo-container {
  width: 100%;
  text-align: center;
}

.login-bg {
  height: 100%;
  background: #a5a498 url("/assets/images/login-bg.svg") no-repeat;
  background-size: cover;
}

.title {
  font-size: 2.1428571429rem;
  color: #ffffff;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  transition: margin linear 0.3s;
}

.title-container {
  flex: 1;
  max-height: 7rem;
}

.login-form {
  flex: 2;
}

.input-field {
  border-radius: 1.7142857143rem;
  font-size: 1rem;
  font-weight: bold;
  color: #000000;
  height: 3.4285714286rem;
  width: 21.0714285714rem;
  border: none;
  padding-left: 1.7857142857rem;
  padding-right: 1.7857142857rem;
  margin-left: auto;
  margin-right: auto;
  background-color: rgba(255, 255, 255, 0.7019607843);
}

.login-button {
  height: 3.4285714286rem;
  width: 21.0714285714rem;
  border-radius: 1.7142857143rem;
  padding-left: 1.7857142857rem;
  padding-right: 1.7857142857rem;
  margin-bottom: 4.1428571429rem;
  margin-left: auto;
  margin-right: auto;
}
.login-button img {
  height: 1.4992857143rem;
  width: 1.3471428571rem;
}
.login-button span {
  font-weight: bold;
  font-size: 0.7142857143rem;
  color: #000000;
}

.confirm-link {
  text-align: center;
  margin-bottom: 4.1428571429rem;
}
.confirm-link a {
  font-weight: bold;
  text-decoration: underline;
}

@media screen and (max-height: 500px) {
  .logo {
    height: 0;
    padding-top: 0;
  }
  .title-container {
    flex: 0;
  }
}
@media screen and (max-height: 330px) {
  .title {
    margin-top: 0.7rem;
    margin-bottom: 0.7rem;
  }
  .confirm-link {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/login/login.component.scss","webpack://./src/_variables.scss"],"names":[],"mappings":"AAEA;EC2CE,uBAAA;EAAA,wBAAA;EAAA,4BAAA;EDvCA,2BAAA;AADF;;AAIA;EACE,WAAA;EACA,kBAAA;AADF;;AAIA;EACE,YAAA;EACA,gEAAA;EACA,sBAAA;AADF;;AAIA;ECyBE,0BAAA;EDvBA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,8BAAA;AADF;;AAIA;ECQE,ODPkB;EAClB,gBAAA;AADF;;AAIA;ECGE,ODFkB;AADpB;;AAIA;ECQE,8BAAA;EAAA,eAAA;EDLA,iBAAA;EACA,cAAA;ECIA,uBAAA;EAAA,uBAAA;EDDA,YAAA;ECCA,6BAAA;EAAA,8BAAA;EDEA,iBAAA;EACA,kBAAA;EACA,mDChBc;ADehB;;AAIA;ECPE,uBAAA;EAAA,uBAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,8BAAA;EDcA,iBAAA;EACA,kBAAA;AADF;AAGE;ECjBA,uBAAA;EAAA,sBAAA;ADkBF;AAIE;EACE,iBAAA;ECvBF,0BAAA;EDyBE,cAAA;AAFJ;;AAMA;EACE,kBAAA;EC9BA,8BAAA;AD4BF;AAIE;EACE,iBAAA;EACA,0BAAA;AAFJ;;AAMA;EACE;IACE,SAAA;IACA,cAAA;EAHF;EAMA;ICrDA,ODsDoB;EAJpB;AACF;AAOA;EACE;IACE,kBAAA;IACA,qBAAA;EALF;EAQA;IACE,aAAA;EANF;AACF","sourcesContent":["@import 'variables';\n\n.logo {\n  @include pixelToRem(width, 174px);\n  @include pixelToRem(height, 174px);\n  @include pixelToRem(padding-top, 58px);\n  transition: all linear 0.3s;\n}\n\n.logo-container {\n  width: 100%;\n  text-align: center;\n}\n\n.login-bg {\n  height: 100%;\n  background: $login-bg-color url('/assets/images/login-bg.svg') no-repeat;\n  background-size: cover;\n}\n\n.title {\n  @include pixelToRem(font-size, 30px);\n  color: #ffffff;\n  margin-top: 1.5rem;\n  margin-bottom: 1.5rem;\n  transition: margin linear 0.3s;\n}\n\n.title-container {\n  @include set-flex(1);\n  max-height: 7rem;\n}\n\n.login-form {\n  @include set-flex(2);\n}\n\n.input-field {\n  @include pixelToRem(border-radius, $input-border-radius);\n  @include pixelToRem(font-size, 14px);\n  font-weight: bold;\n  color: #000000;\n  @include pixelToRem(height, 48px);\n  @include pixelToRem(width, 295px);\n  border: none;\n  @include pixelToRem(padding-left, $input-side-padding);\n  @include pixelToRem(padding-right, $input-side-padding);\n  margin-left: auto;\n  margin-right: auto;\n  background-color: $fade-bg-color;\n}\n\n.login-button {\n  @include pixelToRem(height, 48px);\n  @include pixelToRem(width, 295px);\n  @include pixelToRem(border-radius, $input-border-radius);\n  @include pixelToRem(padding-left, $input-side-padding);\n  @include pixelToRem(padding-right, $input-side-padding);\n  @include pixelToRem(margin-bottom, 58px);\n  margin-left: auto;\n  margin-right: auto;\n\n  img {\n    @include pixelToRem(height, 20.99px);\n    @include pixelToRem(width, 18.86px);\n  }\n\n  span {\n    font-weight: bold;\n    @include pixelToRem(font-size, 10px);\n    color: #000000;\n  }\n}\n\n.confirm-link {\n  text-align: center;\n  @include pixelToRem(margin-bottom, 58px);\n  a {\n    font-weight: bold;\n    text-decoration: underline;\n  }\n}\n\n@media screen and (max-height: 500px) {\n  .logo {\n    height: 0;\n    padding-top: 0;\n  }\n\n  .title-container {\n    @include set-flex(0);\n  }\n}\n\n@media screen and (max-height: 330px) {\n  .title {\n    margin-top: 0.7rem;\n    margin-bottom: 0.7rem;\n  }\n\n  .confirm-link {\n    display: none;\n  }\n}\n","$primary: #ffcd00;\n$secondary: #00a3ae;\n$dark: #707070;\n$base-font-size: 14px;\n\n$header-top-height: 48px;\n$header-bottom-height: 21px;\n$header-border-radius: 24px;\n$header-total-height: $header-top-height + $header-bottom-height;\n$tray-radius: 16px;\n\n$input-border-radius: 24px;\n$input-side-padding: 25px;\n$header-top-color: #ffffff;\n$header-bottom-color: #ededed;\n$text-color: #6b645e;\n$login-bg-color: #a5a498;\n$card-bg-color: #f5f5f5;\n$info-text-color: #a5a498;\n$support-card-bg-color: #7ed0d6;\n$support-card-inactive-color: #bcd8df;\n$support-card-text-color: #f5f5f5;\n$category-border-radius: 16px;\n$product-border-radius: 8px;\n$textarea-border-color: #bcd8df;\n$button-border-radius: 48px;\n$support-button-size: 84px;\n$support-button-margin: 24px;\n$gradient-height: 10%;\n$body-bottom-margin: 15%;\n$input-border-color: #edbf00;\n$image-text-bg-opacity: 0.7;\n$primary-btn-border: rgba(255, 205, 0, 1);\n$fade-bg-color: #ffffffb3;\n\n@mixin set-flex($number) {\n  flex: $number;\n}\n\n@function calculateRem($size) {\n  $remSize: calc($size / $base-font-size);\n  @return #{$remSize}rem;\n}\n\n@mixin pixelToRem($attribute, $size) {\n  #{$attribute}: calculateRem($size);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
